import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-person-badge',
  templateUrl: './person-badge.component.html',
  styleUrls: ['./person-badge.component.scss']
})
export class PersonBadgeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
